import React, {useCallback, useContext} from 'react'
import {WizardContext} from '../Wizard'
import {WizardFormSection} from './WizardFormSection'
import {WizardFormDelivery} from './WizardFormDelivery'
import {WizardFormReference} from './WizardFormReference'
import {SET_PRICE, WORK_TYPE_BOOKN, WORK_TYPE_ORDER} from '../../WizardConstants'

export function WizardFormSelection() {
  const {keyData, workTypeValue, dispatch} = useContext(WizardContext)
  const typeName = workTypeValue !== 'ORDER' ? WORK_TYPE_BOOKN : WORK_TYPE_ORDER

  // console.log(keyData)
  const onChange = useCallback(
    (e) => {
      const value = e.target.value
      // console.log(value)
      dispatch({type: SET_PRICE, price: parseInt(value)})
    },
    [dispatch]
  )

  return (
    <div className='pb-5' data-wizard-type='step-content'>
      <h3 className='mb-5 font-weight-bold text-dark'>{typeName}서 확인</h3>
      {/*{keyData.order_value.map((item, i) =>*/}
      <WizardFormSection data={keyData} />
      {/*)}*/}
      {keyData && keyData.is_delivery === 'Y' && (
        <WizardFormDelivery data={keyData.order_delivery} />
      )}
      {/*{keyData.order_reference.map((item, i) =>*/}
      <WizardFormReference data={keyData && keyData.order_reference} />
      {/*)}*/}
      {keyData.order_status === 5090 && (
        <div>
          가격 : <input className='form-control' defaultValue='0' onChange={onChange} />
        </div>
      )}
    </div>
  )
}
